import Layout from "../shared/Layout";
import React, { useState, useEffect, useCallback } from "react";
import { Toaster, toast } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import { GetStoctSummary } from "../../_services";
import { ClipLoader } from 'react-spinners';
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import CryptoJS from 'crypto-js';

const StockSummary = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [stockDetail, setStockDetail] = useState([]);

    const fetchStockDetailAll = async () => {
        try {
            const data = await GetStoctSummary();
            if (data.isSuccess === 1) {
                setStockDetail((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });

                        return sortedData;
                    }
                    return prevData;
                });
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        }
    };

    useEffect(() => {
        fetchStockDetailAll();
    }, []);

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Product Name',
            selector: row => row.productName,
            sortable: false,
            width: "300px"
        },
        {
            name: 'Color Name',
            selector: row => row.colorTypeName,
            sortable: false,
        },
        {
            name: 'Size Name',
            selector: row => row.sizeTypeName,
            sortable: false,
        },
        {
            name: 'Total Quantity',
            selector: row => row.totalQuantity,
            sortable: false,
        },
        {
            name: 'Total Avaiable Stock',
            selector: row => row.totalAvailStock,
            sortable: false,
        },
        {
            name: 'Total Reject',
            selector: row => row.totalRejectStock,
            sortable: false,
        },
        {
            name: 'Total Consume',
            selector: row => row.totalConsumeStock,
            sortable: false,
        },
    ];

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Stock Detail</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        {/* <div className="search-container col-md-6">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-control"
                        />
                    </div> */}
                    </div>
                </div>

                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={stockDetail || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    )
}

export default StockSummary;